import {StyledBoxColumn} from "../../shared/StyledComponents";
import {Button, Input, Typography} from "@mui/material";
import React, {useState} from "react";
import {setDeviceUnitId} from "../App";
import {PD_SM} from "../../shared/dimens";

function updateDeviceUnitId(deviceUnitId: string) {
  setDeviceUnitId(deviceUnitId);
  window.location.reload();
}

export function EnterDeviceUnitId() {
  const [inputText, setInputText] = useState("");
  const onKeyDown = event => {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  };
  return <StyledBoxColumn
    style={{flexGrow: 1, alignItems: "center", justifyContent: "center", gap: 48, position: "relative"}}>
    <Typography>Device SKU ID</Typography>
    <Input value={inputText} onChange={event => setInputText(event.target.value.toUpperCase())} onKeyDown={onKeyDown}/>
    <Button style={{padding: PD_SM}} onClick={() => updateDeviceUnitId(inputText)}>Update</Button>
  </StyledBoxColumn>;
}